import { useShallow } from "zustand/react/shallow";

import AssistantPanelDropdownMenu from "components/AssistantPanel/components/DropdownMenu";
import { ChevronDown } from "components/icons/generated";
import Button from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import Typography from "ds/components/Typography";

import useChatStore from "../store/useStore";
import { ChatApprovalMode, ChatMode } from "../types";

const APPROVAL_MODE_LABELS: Record<ChatApprovalMode, string> = {
  [ChatApprovalMode.AUTO]: "Auto-approve",
  [ChatApprovalMode.MANUAL]: "Always ask",
};

const ChatApprovalModeSelect = () => {
  const { chatMode, approvalMode, setApprovalMode } = useChatStore(
    useShallow((state) => ({
      chatMode: state.mode,
      approvalMode: state.approvalMode,
      setApprovalMode: state.setApprovalMode,
    }))
  );

  if (chatMode !== ChatMode.BUILD) {
    return (
      <Tooltip
        on={(props) => (
          <Button {...props} endIcon={ChevronDown} variant="ghost" size="small" disabled>
            {APPROVAL_MODE_LABELS[approvalMode]}
          </Button>
        )}
      >
        Approval mode only applies in Build mode.
      </Tooltip>
    );
  }

  return (
    <AssistantPanelDropdownMenu
      triggerComponent={
        <Button endIcon={ChevronDown} variant="ghost" size="small">
          {APPROVAL_MODE_LABELS[approvalMode]}
        </Button>
      }
    >
      {Object.values(ChatApprovalMode).map((mode) => (
        <DropdownMenuItem
          key={mode}
          onAction={() => setApprovalMode(mode)}
          active={mode === approvalMode}
        >
          <Typography variant="p-body3" tag="span">
            {APPROVAL_MODE_LABELS[mode]}
          </Typography>
        </DropdownMenuItem>
      ))}
    </AssistantPanelDropdownMenu>
  );
};

export default ChatApprovalModeSelect;
